import {Injectable} from '@angular/core';
import {HttpCommonService} from "./http-common.service";
import {Observable} from "rxjs/Observable";
import {DatePipe} from "@angular/common";

@Injectable()
export class CityCreditService {

  constructor(private http: HttpCommonService,
              private datePipe: DatePipe) {
  }

  /**
   * 根据编号查询城市
   */
  getCityByCode(areaCode: any): Observable<any> {
    return this.http.get('/city/credit/xhsRest/getCityByCode', {areaCode: areaCode});
  }

  /**
   * 根据编号查询城市图片
   */
  getCityImgByCode(areaCode: any): Observable<any> {
    return this.http.get('/city/credit/xhsRest/getCityImgByCode', {areaCode: areaCode});
  }

  /**
   * 城市(或称号)查询
   */
  cityQuery(key: any): Observable<any> {
    return this.http.get('/city/credit/xhsRest/cityQuery', {key: key});
  }

  /**
   * 地区数据量统计
   */
  getAreaCount(areaId: any, start?: any, end?: any): Observable<any> {
    if (!start && !end) {
      let now = new Date();
      end = this.datePipe.transform(now, 'yyyy-MM-dd');
      now.setDate(now.getDate() - 1);
      start = this.datePipe.transform(now, 'yyyy-MM-dd');
    }
    return this.http.get('/city/credit/xhsRest/statistics/getAreaCount', {
      areaId: areaId,
      startTime: start,
      endTime: end
    });
  }

  /**
   * 省级数据量统计
   * 区域代码 areaId（不传此参数则返回所有省级地区统计）,填写对应省级areaId则返回对应省级下面所有市级数据统计
   */
  getAreaCountPronvince(areaId?: any, start?: any, end?: any): Observable<any> {
    if (!start && !end) {
      let now = new Date();
      end = this.datePipe.transform(now, 'yyyy-MM-dd');
      now.setDate(now.getDate() - 1);
      start = this.datePipe.transform(now, 'yyyy-MM-dd');
    }
    return this.http.get('/city/credit/xhsRest/statistics/getAreaCountPronvince', {
      areaId: areaId ? areaId : '',
      startTime: start,
      endTime: end
    });
  }

  /**
   * 地区数据量分段统计
   * type参数 0 ：按照小时统计最近十次报道量； 1：按照天统计最近十次报道量
   */
  getAreaCountTime(areaId: any, type: any): Observable<any> {
    return this.http.get('/city/credit/xhsRest/statistics/getAreaCountTime', {
      areaId: areaId,
      type: type
    });
  }

  /**
   * 正负面分布统计
   */
  getEmotionCount(areaId: any, start?: any, end?: any): Observable<any> {
    if (!start && !end) {
      let now = new Date();
      end = this.datePipe.transform(now, 'yyyy-MM-dd');
      now.setDate(now.getDate() - 1);
      start = this.datePipe.transform(now, 'yyyy-MM-dd');
    }
    let areaLevel = 2;
    if (areaId.substring(2) == '0000') {
      areaLevel = 1;
    }
    return this.http.get('/city/credit/xhsRest/statistics/getEmotionCount', {
      areaId: areaId,
      startTime: start,
      endTime: end,
      areaLevel: areaLevel
    });
  }

  /**
   * 数据源分布统计
   */
  getDatasourceCount(areaId: any, start?: any, end?: any): Observable<any> {
    if (!start && !end) {
      let now = new Date();
      end = this.datePipe.transform(now, 'yyyy-MM-dd');
      now.setDate(now.getDate() - 1);
      start = this.datePipe.transform(now, 'yyyy-MM-dd');
    }
    let areaLevel = 2;
    if (areaId.substring(2) == '0000') {
      areaLevel = 1;
    }
    return this.http.get('/city/credit/xhsRest/statistics/getDatasourceCount', {
      areaId: areaId,
      startTime: start,
      endTime: end,
      areaLevel: areaLevel
    });
  }

  /**
   * 媒体发表统计
   */
  getMediaCount(areaId: any, start?: any, end?: any): Observable<any> {
    if (!start && !end) {
      let now = new Date();
      end = this.datePipe.transform(now, 'yyyy-MM-dd');
      now.setDate(now.getDate() - 1);
      start = this.datePipe.transform(now, 'yyyy-MM-dd');
    }
    let areaLevel = 2;
    if (areaId.substring(2) == '0000') {
      areaLevel = 1;
    }
    return this.http.get('/city/credit/xhsRest/statistics/getMediaCount', {
      areaId: areaId,
      startTime: start,
      endTime: end,
      areaLevel: areaLevel
    });
  }

  /**
   * 官微热度统计
   */
  getOfficialVCount(areaId: any, start: any, end: any): Observable<any> {
    let areaLevel = 2;
    if (areaId.substring(2) == '0000') {
      areaLevel = 1;
    }
    return this.http.get('/city/credit/xhsRest/statistics/getOfficialVCount', {
      areaId: areaId,
      startTime: start,
      endTime: end,
      areaLevel: areaLevel
    });
  }

  /**
   * 官微热度统计
   */
  getOfficialWXCount(areaId: any, start: any, end: any): Observable<any> {
    let areaLevel = 2;
    if (areaId.substring(2) == '0000') {
      areaLevel = 1;
    }
    return this.http.get('/city/credit/xhsRest/statistics/getOfficialWXCount', {
      areaId: areaId,
      startTime: start,
      endTime: end,
      areaLevel: areaLevel
    });
  }

  /**
   * 区域领域统计
   * 区域代码 areaId（不传此参数则返回所有省级地区统计）,填写对应省级areaId则返回对应省级下面所有市级数据统计
   * type 值为1表示传的areaId是地级市的编码，后台需要根据地址市编码获取省编码
   */
  getFieldCount(areaId?: any, type?: any, start?: any, end?: any): Observable<any> {
    if (!start && !end) {
      let now = new Date();
      end = this.datePipe.transform(now, 'yyyy-MM-dd');
      now.setDate(now.getDate() - 1);
      start = this.datePipe.transform(now, 'yyyy-MM-dd');
    }

    /*if (areaId) {//统计省份时，城市名称有些不对，使用数据库里的城市名称
      return this.http.get('/city/credit/xhsRest/statistics/getFieldCount', {
        areaId: areaId ? areaId : '', queryType: type ? type : '',
        startTime: start ? start : '', endTime: end ? end : '',
      }).mergeMap(result1 => {
        if (result1.stateCode == '1') {
          let saveHttpList = [];
          result1.data.result.forEach(item => {
            saveHttpList.push(this.http.get('/city/credit/xhsRest/getCityByCode', {areaCode: item.areacode}));
          });
          return Observable.forkJoin(saveHttpList).mergeMap(result2 => {
            result2.forEach((item: any, i: number) => {
              result1.data.result[i].areaname = item.data.areaName;
            });
            return Observable.create((observer) => observer.next(result1));
          });
        } else {
          return Observable.create((observer) => observer.next(result1));
        }

      });
    } else {//统计全国时不需要使用数据库里城市名称*/
    return this.http.get('/city/credit/xhsRest/statistics/getFieldCount', {
      areaId: areaId ? areaId : '', queryType: type ? type : '',
      startTime: start ? start : '', endTime: end ? end : '',
    });

  }

  /**
   * 城市荣誉称号查询
   */
  getCityHonor(areaId: any): Observable<any> {
    return this.http.get("/city/credit/xhsRest/getHonorByCity", {
      cityCode: areaId
    });
  }

  /**
   * 城市荣誉称号查询
   */
  getCityZb(areaId: any): Observable<any> {
    return this.http.get("/city/credit/xhsRest/getCityZb", {
      areaId: areaId
    });
  }

  /**
   * 城市是否展示下载舆情报告按钮查询
   */
  showButton(areaId: any): Observable<any> {
    return this.http.get("/city/credit/xhsRest/getShowButton", {
      areaId: areaId
    });
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/city-credit.service.ts